import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BookingService } from 'src/app/services/booking.service';
import { MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Component, OnInit,Inject } from '@angular/core';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { CustomerElegibility } from 'src/app/models/Booking/CustomerElegibility';
import { VehicleReservationCaseDetailsModel } from 'src/app/models/VehicleReservationCaseDetailsModel';



@Component({
  selector: 'customer-eligibility',
  templateUrl: './customer-eligibility.component.html',
  styleUrls: ['./customer-eligibility.component.css']
})
export class CustomerEligibilityComponent implements OnInit {

  faTimesCircle=faTimesCircle;
  customerElegibility:CustomerElegibility[];
  vehicleReservationCaseDetailsModel: VehicleReservationCaseDetailsModel;
  constructor(
    @Inject(MAT_DIALOG_DATA) data,
    private bookingService:BookingService,private dialogRef: MatDialogRef<CustomerEligibilityComponent>,
    private router: Router,public translateService: TranslateService,private domSanitizer: DomSanitizer,
    private dialog: MatDialog ) {
      if(data!=null){
        this.customerElegibility= data.customerElegibility;
        this.vehicleReservationCaseDetailsModel=data.vehicleReservationCaseDetailsModel;
      }
      dialogRef.disableClose = true;
    }

  ngOnInit() {
  }

  close(): void {
    this.dialogRef.close();
    this.router.navigate(['/home']);
  }
  backToHome(){
    this.close();

  }

}
